import React, { useState } from "react";
import {
  Container,
  Button,
  Card,
  Col,
  Row,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import {
  FaFileAlt,
  FaEye,
  FaUserCircle,
} from "react-icons/fa";
import "../../styles/documents.css"
import moment from "moment";



const ListDocuments = ({onChangeLoadPage, items, infoCita}) => {
  const onChangeLoadPageTrazability = (obj) => {
   onChangeLoadPage(obj);    
  };

  return (
    <Container className="my-5">
        <h2 className="mb-0 title-top">Documentos compartidos</h2>

        <Card className="shadow-1 mt-3 padding-card-general">
          <Card.Body className="position-relative">                
            {items.length > 0 ?
              items.map((item, i) =>
              (
                <Row key={i}>
                  <Col xs="2">
                    <FaUserCircle className={(item.hasOwnProperty('uploadUser') && item.uploadUser !== null) ? `format-image color-second` : `format-image color-first`} />
                    <hr className="format-line"></hr>
                  </Col>

                  <Col xs="10" sm="9">
                    <h3 className={(item.hasOwnProperty('uploadUser') && item.uploadUser !== null) ? `mb-3 text-person color-second` : `mb-3 text-person text-blue-2`}>
                      {(item.hasOwnProperty('uploadUser') && item.uploadUser !== null) ? item.uploadUser?.name  : infoCita?.patientDTO?.name ? `${infoCita?.patientDTO?.name} ${infoCita.patientDTO?.middleName ?? ''} ${infoCita?.patientDTO?.lastName} ${infoCita.patientDTO?.seccondSurname ?? ''}` : `${infoCita?.patientDTO?.email}`}
                    </h3>
                    <strong className="date-hour">Fecha: {moment(item.createDate).format("DD-MM-YYYY")}</strong>
                    <strong className="date-hour">Hora: {moment(item.createDate).format("HH:mm")}</strong>
                    <Card className="shadow-1 format-container-card-document">
                      <small className="mb-3 bold">{item.fileName}</small>
                      <Row>
                        <Col xs="2" className="d-block my-auto"><FaFileAlt className="format-ico-document color-document-default"></FaFileAlt></Col>
                        <Col xs="10" sm="8">
                          <ul className="list-reset">
                            <li><FaEye className="color-action-see"></FaEye>
                              <a href={item.url} target="_blank" className="whitout" rel="noreferrer"><span className="text-action color-action-see mx-2">Ver</span></a></li>
                            <br></br>
                            {/* <li>
                              <FaDownload className="color-action-download" />
                              <span className="whitout cursor-pointer text-action color-action-download mx-2" onClick={e=>descargar(item.url)}>Descargar</span>
                              <a href={item.url} target="_blank" className="whitout" rel="noreferrer"><span className="text-action color-action-download mx-2">Descargar</span></a>
                            </li> */}
                          </ul>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              )
              )
              :
              <p className="text-muted">No hay documentos compartidos disponibles</p>
            }
          </Card.Body>
        </Card>
        <Row className='mt-3'>
          <Col className="text-right">
            <Button type="button" variant="danger" className="cancelar-buttom" onClick={() => {onChangeLoadPageTrazability({view: "trazabilidad"})}}>Regresar</Button>
          </Col>
        </Row>
      </Container>
  );
};

export default withTranslation()(ListDocuments);
